<div class="badges">
  <div *ngFor="let badge of badges">
    <a *ngIf="badge.link" [href]="badge.link" target="_blank" rel="noopener" [attr.aria-label]="badge?.title ? badge.title + ' (opens in a new window)' : badge.link">
      <img src="{{getImgPath(badge.image_id)}}" [alt]="badge?.title" matTooltipPosition="above" matTooltip="{{badge.title}}" loading="lazy">
    </a>
    <span *ngIf="!badge.link" class="disabled">
      <img src="{{getImgPath(badge.image_id)}}" [alt]="badge?.title" matTooltipPosition="above" matTooltip="{{badge.title}}" loading="lazy">
    </span>
  </div>
</div>
